<template>

    <div class="container">
    <Row>
      <Col span="24" offset="-1" style="background: white;height: 450px;box-shadow: 0.5px 0.5px 3px 0.5px darkgray" >
      <br>
      <br>
      <Col span="10" offset="1" v-if="projectPictureRows!=null && projectPictureRows.length>0">
        <Carousel autoplay loop>
            <CarouselItem v-for="(item,index) in projectPictureRows" :key="index">
            <img :src="item.imgPath" width="100%" />
            </CarouselItem>
        </Carousel>
      </Col>
      <Col span="10" offset="1" v-if="projectPictureRows==null || projectPictureRows.length==0">
        <img :src="img4" width="100%" height="400px"/>
      </col>
      <Col span="10" offset="1"  align="left" >
      <Col span="24" style="font-size: 24px;line-height:25px;">
      {{project.projectTitle}}
      </Col>
      <Col span="2"> 
	        <div @click="addCollection()"> <template v-if="2==icon"><Icon type="md-star" size='25' style="color:orange"/></template>
          <template v-if="1==icon"><Icon type="md-star-outline"  size='25' style="color:orange" /></template></div>
       </Col>
      <br/>
      <br/>
      <Col span="10" style="font-size: 14px; ">
      转让底价:<span style="color:red;font-size: 18px;">{{project.money}}</span>万元
      </Col>
      
      <Col span="10" offset="3" style="font-size: 14px; ">所在地：{{project.projectProvince}}
      </Col> 
   
      <br/>
      <br/>
       
      <Col span="10"  style="font-size: 14px; " >
      信息披露期：<span style="color:orange;">{{project.infoDisclosePeriod}}</span>
      </Col>
     
      <Col span="11" offset="3" style="font-size: 14px; ">所属行业：{{project.industry}}
      </Col>  
      
      <br/>
      <br/>
      <Col  span="10" style="font-size: 14px; " >
      保证金： <span style="color:red;">{{project.payDeposit}}</span>
      </Col>
     
      <Col span="10" offset="3" style="font-size: 14px; ">
      经济性质：{{project.economicNature}}
      </Col>
       <br>
      <br>

      <Col offset="5" span="10" style="background: orange; font-size: 25px; ">
      <Icon type="md-call" />
      {{project.phone}}4006-010-661
      </Col>
       <br/>
      <br/>
       <br/>
      <Col>
      <Col  span="15" style="line-height:25px;font-size: 14px; ">
      信息披露开始时间：{{project.infoDiscloseStart}}<br><br>
      信息披露结束时间：{{project.infoDiscloseEnd}}<br>
      </Col>
      </Col>
       <br>
       <br>
      <Col span="24" offset="0" style="border: 1px solid ;border-color: lightgray;background: #f6f6f6;line-height:25px;font-size: 14px;">
    {{projectTxt.projectOutline}}
      </Col>
      </Col>
      </Col>
    </Row>
    <br/>
      <!--<Row>
        <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;height: 110px">
        <Col span="6" class="info" v-for="(item,index) in info" :key="index">{{item}}</Col>
        </Col>
       </Row>
       <br/>-->
       <Row>
        <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;height: 110px">
        <Col span="6" class="info" ><a href="#1" style="font-size:18px;color:black;">基本信息</a></Col>
        <Col span="6" class="info" ><a href="#2" style="font-size:18px;color:black;">资产情况</a></Col>
        <Col span="6" class="info" ><a href="#3" style="font-size:18px;color:black;">交易条件与受让方资格条件</a></Col>
        <Col span="6" class="info" ><a href="#4" style="font-size:18px;color:black;">其他</a></Col>
        </Col>
       </Row>
       <br/>
    <Row id="1">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;">
      <Col span="2" offset="1" style="font-size: 23px">
     
      <span style="border-bottom:3px solid orange;font-family: 黑体">基本信息</span>
      
      </Col>
      <Divider />

      <Col offset="1" span="22">
      <table width="100%"  >
        <tr>
          <td>项目名称</td><td>{{projectInfo.projectName}}</td><td>项目编号</td><td>{{projectInfo.projectId}}</td>
        </tr>
        <tr>
          <td>转让方名称</td><td>{{projectInfo.companyName}}</td><td>经济性质</td><td>{{projectInfo.economicNature}}</td>
        </tr>
        <tr>
          <td>转让底价</td><td>{{project.money}}</td><td>资金来源</td><td>{{projectInfo.assetsSource}}</td>
        </tr>
        <tr>
          <td>标的是否存在抵押情况</td><td v-if="projectInfo.stateOwnedLand==1">是<td v-else>否</td><td>权利人是否有意向行使优先购买权</td><td v-if="projectInfo.priorityAssignee==1">是<td v-else>否</td>
        </tr> <tr>
        <td>交易机构</td><td>{{projectInfo.tradeInstitution}}</td><td>信息来源</td><td>{{projectInfo.infoSource}}</td>
      </tr>
        <tr>
          <td>转让方承诺</td><td colspan="3">{{projectInfo.transferorPromise}}</td>
        </tr> <tr>
        <td>核心资产介绍</td><td colspan="3">{{projectTxt.scaleOperation}}</td>
      </tr> 
       <br>
       <br>
     
      </table>
      </Col>
      </Col>
    </Row>
    <br/>
    <Row id="2">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray; ">
       <Col span="2" offset="1" style="font-size: 23px">
     
      <span style="border-bottom:3px solid orange;font-family: 黑体">资产情况</span>
      
      </Col>
       <Divider />
      <Col offset="1" span="22">
     <table width="100%" >
         <tr><td colspan="4">土地</td></tr>
       <tr><td >坐落位置</td><td colspan="3">{{assetFirst.placeName}}</td></tr>
          <tr><td >土地证号</td><td>{{assetFirst.idNumber}}</td><td >土地面积（平方米）</td><td>{{assetFirst.acreage}}</td></tr>
           <tr><td >用途</td><td>{{assetFirst.purpose}}</td><td >类型</td><td>{{assetFirst.type}}</td></tr>
            <tr><td >使用年限</td><td>{{assetFirst.durableYears}}</td><td >已用年限</td><td>{{assetFirst.usedYears}}</td></tr>
             <tr><td colspan="4">房屋建筑物</td></tr>
              <tr><td >坐落位置</td><td colspan="3">{{assetSecond.placeName}}</td></tr>
          <tr><td >土地证号</td><td>{{assetSecond.idNumber}}</td><td >土地面积（平方米）</td><td>{{assetSecond.acreage}}</td></tr>
           <tr><td >用途</td><td>{{assetSecond.purpose}}</td><td >类型</td><td>{{assetSecond.type}}</td></tr>
            <tr><td >使用年限</td><td>{{assetSecond.durableYears}}</td><td >已用年限</td><td>{{assetSecond.usedYears}}</td></tr>
              <tr><td colspan="4">其他</td></tr>
              <tr><td >名称</td><td colspan="3">{{assetThird.placeName}}</td></tr>
                 <tr><td >计量单位</td><td>{{assetThird.unit}}</td><td >所在地</td><td>{{assetThird.location}}</td></tr>
           <tr><td >型号</td><td>{{assetThird.model}}</td><td >数量</td><td>{{assetThird.amount}}</td></tr>

     </table>
     <br>
     <br>
      </col>
      </Col>
        </Row>
          <br/>
    <Row id="3">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;">
      <Col span="6" offset="1" style="font-size: 23px">
       <span style="border-bottom:3px solid orange;font-family: 黑体">交易条件与转让方资格条件</span>
      </col>
       <Divider />
       <Col offset="1"  span="22">
       <table width="100%" >
           <tr><td>转让方名称</td><td>{{projectInfo.companyName}}</td><td>转让方决策文件类型</td><td>{{projectApproval.fileType}}</td></tr>
            <tr><td>转让方决策文件类型说明</td><td colspan="3">{{projectApproval.fileTypeExplain}}</td></tr>
             <tr><td>批准文件名称</td><td>{{projectApproval.approveFileName}}</td><td>批准单位名称</td><td>{{projectApproval.approveCompanyName}}</td></tr>
               <tr><td>价款支付方式</td><td>{{projectPrerequisites.paymentMethod}}</td><td>保证金设定</td><td>{{projectPrerequisites.payMode}}</td></tr>
                <tr><td>与转让相关的其他条件</td><td colspan="3">{{projectTxt.otherConditions}}</td></tr>
                 <tr><td>受让方资格条件</td><td colspan="3">{{projectTxt.prerequisites}}</td></tr>
                   <tr><td>其他需要披露的内容</td><td colspan="3">{{projectTxt.otherDisclosures}}</td></tr>
         </table>
       <br>
       <br>
       </Col>
      </Col>
      </Row>
       <br/>
   
    <Row id="4">
      <Col span="24" offset="-1" style="background: white;box-shadow: 0.5px 0.5px 3px 0.5px darkgray;overflow:hidden;">
      <Col span="1" offset="1" style="font-size: 23px">
      <span style="border-bottom:3px solid orange;font-family: 黑体">其他</span>
      </col>
        <Divider />
        <Col span="22" offset="1">
        <table width="100%" >
       <tr><td style="width:25%;">意向受让方登录受理地址</td><td style="width:75%">{{collectAddress[0].attrValue}}</td></tr>
       
        </table>
        <br><br>
        </Col>
      </Col>
      </Row>
    </div>

</template>

<script>
  /*  import itable from "./components/table"; */

    export default {
   /*  components: {itable}, */
      data(){
        return{
            project: [],
            projectInfo: [],
            projectTxt: [],
            projectApproval:[],
            projectPrerequisites:[],
            Enclosure:[],
            projectPictureRows:[],
            projectAssetValuationDetails:[],
            collectAddress:[{attrName:'意向受让方登记受理地址',attrValue:''}],
            img4:"../../../static/noImg.png",
            assetFirst:{
              projectId	      :"", //string		项目id
              placeName	      :"", //string	200	项目名称/坐落位置
              idNumber      	:"", //date	100	证号
              acreage	        :"", //date	100	面积
              purpose	        :"", //string	100	用途
              subsidiary      :"", //附属设备/土地类型
              type	          :2, //string	100	类型
              durableYears	  :"", //string	100	使用年限
              usedYears     	:"", //string	100	已用年限
            },
            assetSecond:{
              projectId     	:"", //string		项目id
              placeName	      :"", //string	200	项目名称/坐落位置
              idNumber      	:"", //date	100	证号
              purpose	        :"", //string	100	用途
              acreage	        :"", //date	100	面积
              subsidiary      :"", //附属设备/土地类型
              type	          :3, //string	100	类型
              durableYears	  :"", //string	100	使用年限
              usedYears	      :"", //string	100	已用年限
            },
            assetThird:{
              projectId     	:"", //string		项目id
              placeName	      :"", //string	200	项目名称/坐落位置
              unit	          :"", //string	100	计量单位
              location	      :"", //string	100	所在地
              type	          :99, //string	100	类型
              model	          :"", //string	100	型号
              amount        	:"", //string	100	数量
            },
            info:['基本信息','资产情况','交易条件与受让方资格条件','其他']
        
        }
      },
      mounted(){
         this.getProject();
      },
      methods:{
        getProject:function(){
          let that=this;
          protocol.param_projectDetail.data.projectId=this.$route.query.detailId;      
          http.gets(protocol.param_projectDetail,protocol.param_projectDetail.data).then(response => {
                let {msg,code,project,projectInfo,projectFinance,projectPrerequisites,projectAssetValuationDetailsRows,
                projectTxt,projectAttachment,projectAssetValuationDetails,projectApproval,projectAttrRows,projectPictureRows} = response.data;
                console.log(msg);
            if (code === 0) {
                if(project!=null){
                  this.project = project;
                }
                if(projectInfo!=null){
                    this.projectInfo = projectInfo;
                }
                if(projectTxt!=null){
                    this.projectTxt = projectTxt;
                }
                if(projectApproval!=null){
                    this.projectApproval = projectApproval;
                }
                if(projectPrerequisites!=null){
                    this.projectPrerequisites = projectPrerequisites;
                }
                for(let item in projectAssetValuationDetailsRows){
                    if(projectAssetValuationDetailsRows[item].type == 2){
                      this.assetFirst  = projectAssetValuationDetailsRows[item]
                    }else if(projectAssetValuationDetailsRows[item].type == 3){
                      this.assetSecond = projectAssetValuationDetailsRows[item]
                    }else if(projectAssetValuationDetailsRows[item].type == 99){
                      this.assetThird  = projectAssetValuationDetailsRows[item]
                    }
                }
               //自定义属性
                if(projectAttrRows!=null && projectAttrRows.length>0){
                        this.collectAddress = projectAttrRows;
                }
                //图片信息
                if(projectPictureRows!=null && projectPictureRows.length>0){
                        this.projectPictureRows = projectPictureRows;
                }
            }else{
              this.project = [];
              this.projectInfo = [];
              this.projectTxt = [];
              this.projectApproval = [];
              this.projectPrerequisites = [];
              this.assetFirst = [];
              this.assetSecond = [];
              this.assetThird = [];
            }
          });
},
addCollection:function(){
    protocol.param_addCollection.data.collectionId=this.$route.query.detailId; ;      
    protocol.param_addCollection.data.type = '1';
    http.posts(protocol.param_addCollection,protocol.param_addCollection.data).then(response => {
         let {msg,code} = response.data;
         if(code=='401'){
            //this.$message({ type: "warning", message: "还未登录，请先登录" });
            //alert("还未登录，请先登录");
            this.$Message.info("还未登录，请先登录");
            this.$router.push({path:'/load'});
          }else if(code==0){
            this.$Message.info(msg);
          }else{
            this.icon=2;
            this.$Message.info(msg);
          }
      });
}
    /*   getProduct () {

          setTimeout(() => {
            this.dataList = this.dataList.find(item => item.id === this.id);
          }, 0);
        }, */

      /*   init() {
          this.$http.get('/api/good').then((response) => {
            response = response.body;
            const ERR_OK = 0;
            if(response.errno === ERR_OK) {
              this.dataList = response.data;
            }
          });
        } */
      }

    }
</script>

<style scoped>
 td{
    border: 1px solid lightgray;
    height: 50px;
    font-size: 14px;
  }
  tr{ border: 1px solid lightgray}
  tr:hover{
    background: whitesmoke;
  }
  td:nth-child(2n-1){
    background:#F5F5F5;
    width:240px;

  }
  td:nth-child(2n){
    
     width:240px;
  }


  table{border-collapse: collapse;
    cursor: pointer;
    padding: 5%;
   
  }
    .info{
      line-height:110px; 
      font-size:15px;
       cursor: pointer;
    }
    .info:hover{
      color: orange
     
    }
</style>



// WEBPACK FOOTER //
// src/views/detail/detail3.vue